export default "__VITE_ASSET__DLXY1Tq8__"